import { api } from '~/data/api'
import {
  IAircraftWithInspections,
  IPaginatedAircraftDocuments,
} from '~/modules/manager_view/data/type-aircrafts-with-assets'
import { IAircraft, IPaginated, IPaginationParams } from '~/utils/types'

export interface IUpdateAircraftProps {
  aircraft_id?: string
  aircraft: IAircraft
}

export async function updateAircraft({ aircraft_id, aircraft }: IUpdateAircraftProps) {
  const response = await api().put(`/aircraft/${aircraft_id}`, aircraft)
  return response.data
}

export async function createAircraft(aircraft: Partial<IAircraft>) {
  const response = await api().post(`/aircraft`, aircraft)
  return response.data
}

export async function deleteAircraft(aircraft_id: string) {
  const response = await api().delete(`/aircraft/${aircraft_id}`)
  return response.data
}

export interface IVerifySerialNumber {
  asset_model_id: string
  serial_number: string
}
export interface IVerifySerialNumberResponse extends IVerifySerialNumber {
  available: boolean
}
export async function verifySerialNumber({
  serial_number,
  asset_model_id,
}: IVerifySerialNumber): Promise<IVerifySerialNumberResponse> {
  return await (
    await api().post('/aircraft/verify_sn', {
      serial_number,
      asset_model_id,
    })
  ).data
}

export interface IUpdateAircraftImageProps {
  aircraft_id: string
  image: File
}

export async function updateAircraftImage({ aircraft_id, image }: IUpdateAircraftImageProps) {
  const formData = new FormData()
  formData.append('aircraft_photo', image)

  return await api().put(`/aircraft/${aircraft_id}/import_photo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export async function deleteAircraftImage(aircraft_id: string) {
  return await api().delete(`/aircraft/${aircraft_id}/delete_photo`)
}

interface IParams {
  pagination: IPaginationParams
  query?: string
}
export async function listPaginatedAssets(props: IParams): Promise<IPaginated<IAircraft>> {
  const response = await api().get(`/aircraft`, {
    params: {
      ...props.pagination,
      query: props.query ?? '',
    },
  })

  return response.data
}
export async function listAuditedAssets(company_id: string) {
  const response = await api().get(`/aircraft/audit_count/${company_id}`)
  return response.data
}

interface UseListAuditedWithAssetsProps {
  page: number
  limit: number
  search?: string
  asset_type?: string
}

export async function listAuditedWithAssets(
  props: UseListAuditedWithAssetsProps,
  company_id: string,
): Promise<IPaginatedAircraftDocuments> {
  const response = await api().get(`/aircraft_with_audits/${company_id}`, {
    params: {
      page: props.page,
      limit: props.limit,
      search: props.search,
      asset_type: props.asset_type,
    },
  })
  return response.data
}

export async function getAircraftWithAudits(
  aircraft_id: string,
  company_id: string,
): Promise<IAircraftWithInspections> {
  const response = await api().get(`/aircraft_with_audits/${company_id}/aircraft/${aircraft_id}`)
  return response.data
}

export async function getAircraftById(aircraft_id: string): Promise<IAircraft> {
  const response = await api().get(`/aircraft/${aircraft_id}`)
  return response.data
}

export type TListAircraftProps = Pick<IAircraft, 'aircraft_model' | 'owner' | '_id'>

export async function listAircrafts(props?: TListAircraftProps): Promise<IAircraft[]> {
  const { data } = await api().get('/aircraft', {
    params: props,
  })
  return data.docs
}
